import { Toolbar } from '#components/Toolbar'
import { useMst } from '#state'
import { ButtonMode } from '#state/types'

import { UndoRedo } from '../buttons/UndoRedo'

import { AlignmentButtons } from './Alignment'
import { HyperlinkButton } from './Hyperlink'
import { NewCommentButton } from './NewComment'
import { StyleButtons } from './Style'

export const FormattingButtons = ({
  overflow = false,
  mode,
}: {
  overflow?: boolean
  mode?: ButtonMode
}) => {
  const { currentScript } = useMst()

  return (
    <Toolbar.ButtonGroup spacing={0}>
      {/* no divider is needed when the buttons are displayed within the overflow menu or when title page is the first element */}
      {!overflow && !currentScript?.titlePage.titlePageVisible && (
        <Toolbar.Divider />
      )}
      {mode !== 'mini' && (
        <>
          <Toolbar.ButtonGroup spacing={0}>
            <UndoRedo />
          </Toolbar.ButtonGroup>
          <Toolbar.Divider />
          <Toolbar.ButtonGroup spacing={0}>
            <StyleButtons />
          </Toolbar.ButtonGroup>
        </>
      )}
      {!currentScript?.isInk && (
        <>
          <Toolbar.Divider />
          <Toolbar.ButtonGroup spacing={0}>
            <AlignmentButtons />
          </Toolbar.ButtonGroup>
          <>
            <Toolbar.Divider />
            <HyperlinkButton />
          </>
        </>
      )}
      <NewCommentButton />
    </Toolbar.ButtonGroup>
  )
}
